export class ItemGeneralListado {
    id: String;
    Titulo: String;
    Descripcion: String;
    Imagen: String;
    UrlDestination: String;
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/itemClasses/itemListadoGeneral.class.ts